// Helper to generate consistent datapolis records
const names = [
    'Budi Santoso', 'Siti Rahayu', 'Ahmad Hidayat', 'Dewi Lestari', 'Eko Prasetyo',
    'Fitri Handayani', 'Gunawan Wijaya', 'Hana Permata', 'Irfan Maulana', 'Joko Susilo',
    'Kartini Wulandari', 'Lukman Hakim', 'Maya Sari', 'Nugroho Adi', 'Oktavia Putri',
    'Pandu Setiawan', 'Qori Amalia', 'Rizky Firmansyah', 'Suryani Dewi', 'Teguh Prabowo',
    'Umi Kalsum', 'Vina Oktaviani', 'Wahyu Nugroho', 'Xenia Maharani', 'Yusuf Abdillah',
    'Zahra Aulia', 'Andi Kurniawan', 'Bella Safitri', 'Cahyo Wibowo', 'Dina Marlina',
    'Erwin Saputra', 'Farida Nurhasanah', 'Gilang Ramadhan', 'Hesti Purnama', 'Ilham Akbar',
    'Jasmine Azzahra', 'Kevin Pratama', 'Linda Permatasari', 'Mulyadi Hasan', 'Nadia Kusuma',
    'Oscar Tandjung', 'Putri Ayu', 'Rendra Mahardika', 'Sinta Dewanti', 'Taufik Hidayat',
    'Ulfa Rahmawati', 'Vicky Anggara', 'Winda Sari', 'Yoga Aditya', 'Zulfikar Rahman',
]

const occupations = ['Karyawan Swasta', 'PNS', 'Wiraswasta', 'Dokter', 'Guru', 'TNI', 'Polisi', 'Petani', 'Programmer', 'Akuntan']
const packages = ['A1', 'A2', 'C1', 'C2', 'C3', 'C4', 'C6']
const conditionStatuses = ['Polis Aktif', 'Polis Tidak Aktif', 'Polis Batal']
const claimStatuses = [null, null, null, null, 'Processing', 'Approve', 'Rejected'] // mostly null
const genders = ['Male', 'Female']

function generateNIK(index) {
    const prefix = '3275' // Jakarta
    const date = String(10 + (index % 20)).padStart(2, '0')
    const month = String(1 + (index % 12)).padStart(2, '0')
    const year = String(80 + (index % 20)).padStart(2, '0')
    const seq = String(1000 + index).padStart(4, '0')
    return `${prefix}${date}${month}${year}${seq}`
}

function generatePolicyNumber(index) {
    const year = 2024 + Math.floor(index / 30)
    const seq = String(index + 1).padStart(6, '0')
    return `POL-${year}-${seq}`
}

function generateCertificateNumber(index) {
    const year = 2024 + Math.floor(index / 30)
    const seq = String(index + 1).padStart(8, '0')
    return `CERT-${year}-${seq}`
}

function generateDate(baseYear, baseMonth, offsetDays) {
    const d = new Date(baseYear, baseMonth - 1, 1 + offsetDays)
    return d.toISOString().split('T')[0]
}

const pusatMapping = [
    { pusat_id: '4', nama_pusat: 'Bank Sejahtera Pusat' },
    { pusat_id: '10', nama_pusat: 'Bank Makmur Pusat' },
    { pusat_id: '11', nama_pusat: 'Bank Mandala Pusat' },
]

const cabangMapping = [
    { cabang_id: '5', pusat_id: '4', nama_cabang: 'Bank Sejahtera Cab. Jakarta Selatan' },
    { cabang_id: '12', pusat_id: '4', nama_cabang: 'Bank Sejahtera Cab. Bandung' },
    { cabang_id: '13', pusat_id: '4', nama_cabang: 'Bank Sejahtera Cab. Surabaya' },
    { cabang_id: '14', pusat_id: '10', nama_cabang: 'Bank Makmur Cab. Jakarta Barat' },
    { cabang_id: '15', pusat_id: '10', nama_cabang: 'Bank Makmur Cab. Semarang' },
    { cabang_id: '16', pusat_id: '11', nama_cabang: 'Bank Mandala Cab. Medan' },
    { cabang_id: '17', pusat_id: '11', nama_cabang: 'Bank Mandala Cab. Makassar' },
]

const insuranceNames = ['Askred Sample TEST', 'PT Asuransi Nusantara Jaya']

function generateDatapolis() {
    const records = []
    for (let i = 0; i < 50; i++) {
        const cabang = cabangMapping[i % cabangMapping.length]
        const pusat = pusatMapping.find(p => p.pusat_id === cabang.pusat_id)
        const tenor = [12, 24, 36, 48, 60][i % 5]
        const startMonth = 1 + (i % 12)
        const startYear = 2024 + Math.floor(i / 24)
        const periodeAwal = generateDate(startYear, startMonth, i % 28)
        const endDate = new Date(startYear, startMonth - 1 + tenor, 1 + (i % 28))
        const periodeAkhir = endDate.toISOString().split('T')[0]
        const mainCredit = [50000000, 75000000, 100000000, 150000000, 200000000, 250000000, 300000000, 500000000][i % 8]
        const premiumRate = [0.5, 0.75, 1.0, 1.25, 1.5, 2.0][i % 6]
        const premium = Math.round(mainCredit * premiumRate / 100)
        const conditionStatus = conditionStatuses[i < 35 ? 0 : (i < 45 ? 1 : 2)]
        const gender = genders[i % 2]
        const dobYear = 1970 + (i % 30)
        const dobMonth = 1 + (i % 12)
        const coverageOptions = [[1, 2], [1, 2, 3], [1, 2, 4], [1, 2, 3, 4], [1], [1, 2]]
        const coverage = JSON.stringify(coverageOptions[i % coverageOptions.length])

        const premiumRateNd = +(premiumRate * 0.4).toFixed(4)
        const premiumRatePa = +(premiumRate * 0.3).toFixed(4)
        const premiumNd = Math.round(mainCredit * premiumRateNd / 100)
        const premiumPa = Math.round(mainCredit * premiumRatePa / 100)

        records.push({
            uuid: `dp-${String(i + 1).padStart(4, '0')}`,
            certificate_number: generateCertificateNumber(i),
            policy_number: generatePolicyNumber(i),
            name: names[i],
            id_card_number: generateNIK(i),
            id_card_type: 'KTP',
            gender,
            date_of_birth: generateDate(dobYear, dobMonth, i % 28),
            address: `Jl. Contoh No. ${i + 1}, RT 0${(i % 9) + 1}/RW 0${(i % 5) + 1}, Jakarta`,
            occupation: occupations[i % occupations.length],
            liquid_credit_number: `LC-${2024}-${String(i + 1).padStart(6, '0')}`,
            main_credit: mainCredit,
            plafon_credit: mainCredit,
            premium_rate: premiumRate,
            origin_premium: premium,
            extra_premium: 0,
            premium,
            premi: premium,
            tenor,
            waiting_periode: '30 hari',
            periode_awal: periodeAwal,
            periode_akhir: periodeAkhir,
            created_at: generateDate(startYear, startMonth, (i % 28) - 7),
            stnc: generateDate(startYear, startMonth, (i % 28) - 3),
            age_when_credit_aggrement: new Date(startYear, startMonth - 1, 1).getFullYear() - dobYear,
            coverage,
            condition_status: conditionStatus,
            claim_status: claimStatuses[i % claimStatuses.length],
            policy_status: conditionStatus === 'Polis Aktif' ? 'Approved' : (conditionStatus === 'Polis Batal' ? 'Cancelled' : 'Expired'),
            insurance_coverage_package: packages[i % packages.length],
            nama_pusat: pusat.nama_pusat,
            pusat_id: pusat.pusat_id,
            nama_cabang: cabang.nama_cabang,
            cabang_id: cabang.cabang_id,
            company_name: insuranceNames[i % insuranceNames.length],
            insurance_id: String((i % insuranceNames.length) + 1),
            company_reasuransi: 'PT Reasuransi Nasional Indonesia',
            premium_rate_nd: premiumRateNd,
            premium_nd: premiumNd,
            premium_rate_pa: premiumRatePa,
            premium_pa: premiumPa,
            premium_gross: premium + premiumNd + premiumPa,
            download_certif_status: conditionStatus === 'Polis Aktif' ? 'available' : null,
            project_id: 1,
            // Invoice data
            no_invoice_individu: `INV-${startYear}-${String(i + 1).padStart(6, '0')}`,
            tanggal_polis_aktif: periodeAwal,
            premium_amount: premium,
            due_date: generateDate(startYear, startMonth, (i % 28) + 30),
            status_payment_bank: i % 3 === 0 ? 'outstanding' : 'paid',
            payment_date_bank: i % 3 === 0 ? null : generateDate(startYear, startMonth, (i % 28) + 15),
            due_date_asuransi: generateDate(startYear, startMonth, (i % 28) + 60),
            status_payment_insurance: i % 4 === 0 ? 'outstanding' : 'paid',
            payment_date_insurance: i % 4 === 0 ? null : generateDate(startYear, startMonth, (i % 28) + 45),
        })
    }
    return records
}

export const datapolisRecords = generateDatapolis()

// Activity logs for datapolis
export const datapolisLogs = [
    { id: '1', datapolis_id: 'dp-0001', created_by: 'sysadmin', message: 'Data polis berhasil dibuat', created_at: '2024-01-15 10:00:00' },
    { id: '2', datapolis_id: 'dp-0001', created_by: 'insurance', message: 'Dokumen persyaratan diunggah', created_at: '2024-01-16 14:30:00' },
    { id: '3', datapolis_id: 'dp-0001', created_by: 'sysadmin', message: 'Polis diaktifkan', created_at: '2024-01-17 09:00:00' },
    { id: '4', datapolis_id: 'dp-0002', created_by: 'sysadmin', message: 'Data polis berhasil dibuat', created_at: '2024-02-10 11:00:00' },
    { id: '5', datapolis_id: 'dp-0002', created_by: 'insurance', message: 'Review dokumen selesai', created_at: '2024-02-12 16:00:00' },
]

// Documents for datapolis
export const datapolisDocuments = [
    { uuid: 'doc-001', datapolis_uuid: 'dp-0001', type: 'medis', file_name: 'hasil_mcu_budi.pdf', path_file: '', file_type: 'pdf', created_at: '2024-01-16 14:30:00' },
    { uuid: 'doc-002', datapolis_uuid: 'dp-0001', type: 'tambahan', file_name: 'ktp_budi.pdf', path_file: '', file_type: 'pdf', created_at: '2024-01-16 14:35:00' },
    { uuid: 'doc-003', datapolis_uuid: 'dp-0002', type: 'medis', file_name: 'hasil_mcu_siti.pdf', path_file: '', file_type: 'pdf', created_at: '2024-02-10 11:30:00' },
    { uuid: 'doc-004', datapolis_uuid: 'dp-0003', type: 'medis', file_name: 'hasil_mcu_ahmad.pdf', path_file: '', file_type: 'pdf', created_at: '2024-03-05 09:15:00' },
    { uuid: 'doc-005', datapolis_uuid: 'dp-0003', type: 'tambahan', file_name: 'slip_gaji_ahmad.pdf', path_file: '', file_type: 'pdf', created_at: '2024-03-05 09:20:00' },
]
